import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react';
import authReducer from './slice/authSlice';
import commonServiceApi from './services/common/commonServiceApi';
import AdmissionBoardServiceApi from './services/AdmissionBoardApproval/AdmissionBoardServiceApi';
import BoardCommitteeServiceApi from './services/BoardCommitteeApproval/BoardCommitteeServiceApi';
import authApi from './services/login/authApi';
import ViewIndividualMemberServiceApi from './services/ViewIndividulaMember/ViewIndividualMemberServiceApi';
import PaymentReconciliationApi from './services/PaymentReconciliation/PaymentReconciliationApi';
import MembershipTaskListServiceApi from './services/MembershipTaskList/MembershipTaskListServiceApi';
import MembershipPricingServiceApi from './services/MembershipPricing/MembershipPricingServiceApi';
import DropdownManagementApi from './services/FieldManagement/DropdownManagement/DropdownManagementApi';
import EmailTemplateManagementApi from './services/FieldManagement/EmailTemplateManagement/EmailTemplateManagementApi';
import ViewEditEventApi from './services/EventManagement/ViewEditEvent/ViewEditEventApi';
import EventFeedbackQuestionApi from './services/EventManagement/EventFeedBackQuestion/EventFeedbackQuestionApi';
import EventQuestionAnswerApi from './services/EventManagement/EventQuestionAnswer/EventQuestionAnswerApi';
import EventManagementApi from './services/EventManagement/EventManagementApi';
import EventGalleryApi from './services/EventGallery/EventGalleryApi';
import ResourseApi from './services/ResourceManagement/ResourseApi';
import CommitteeWorkGroupApi from './services/CommiteeWorkGroup/CommitteWorkGroupServiceApi';
import HonoraryMembershipServiceApi from './services/HonoraryMembers/HonoraryMembershipServiceApi';
import ManualEventCertServiceApi from './services/ManualEventCert/ManualEventCertServiceApi';
import NotificationBarServiceApi from './services/NotificationBar/NotificationBarServiceApi';
import BookingCancelationListServiceApi from './services/BookingCancelation/BookingCancelationListServiceApi';
export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [commonServiceApi.reducerPath]: commonServiceApi.reducer,
    [MembershipTaskListServiceApi.reducerPath]: MembershipTaskListServiceApi.reducer,
    [AdmissionBoardServiceApi.reducerPath]: AdmissionBoardServiceApi.reducer,
    [BoardCommitteeServiceApi.reducerPath]: BoardCommitteeServiceApi.reducer,
    [ViewIndividualMemberServiceApi.reducerPath]: ViewIndividualMemberServiceApi.reducer,
    [PaymentReconciliationApi.reducerPath]: PaymentReconciliationApi.reducer,
    [MembershipPricingServiceApi.reducerPath]: MembershipPricingServiceApi.reducer,
    [DropdownManagementApi.reducerPath]: DropdownManagementApi.reducer,
    [EmailTemplateManagementApi.reducerPath]: EmailTemplateManagementApi.reducer,
    [ViewEditEventApi.reducerPath]: ViewEditEventApi.reducer,
    [EventFeedbackQuestionApi.reducerPath]: EventFeedbackQuestionApi.reducer,
    [EventQuestionAnswerApi.reducerPath]: EventQuestionAnswerApi.reducer,
    [EventManagementApi.reducerPath]: EventManagementApi.reducer,
    [EventGalleryApi.reducerPath]: EventGalleryApi.reducer,
    [ResourseApi.reducerPath]: ResourseApi.reducer,
    [CommitteeWorkGroupApi.reducerPath]: CommitteeWorkGroupApi.reducer,
    [HonoraryMembershipServiceApi.reducerPath]: HonoraryMembershipServiceApi.reducer,
    [ManualEventCertServiceApi.reducerPath]: ManualEventCertServiceApi.reducer,
    [NotificationBarServiceApi.reducerPath]: NotificationBarServiceApi.reducer,
    [BookingCancelationListServiceApi.reducerPath]: BookingCancelationListServiceApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    authApi.middleware,
    commonServiceApi.middleware,
    MembershipTaskListServiceApi.middleware,
    AdmissionBoardServiceApi.middleware,
    BoardCommitteeServiceApi.middleware,
    ViewIndividualMemberServiceApi.middleware,
    PaymentReconciliationApi.middleware,
    MembershipPricingServiceApi.middleware,
    DropdownManagementApi.middleware,
    EmailTemplateManagementApi.middleware,
    ViewEditEventApi.middleware,
    EventFeedbackQuestionApi.middleware,
    EventQuestionAnswerApi.middleware,
    EventManagementApi.middleware,
    EventGalleryApi.middleware,
    ResourseApi.middleware,
    CommitteeWorkGroupApi.middleware,
    HonoraryMembershipServiceApi.middleware,
    ManualEventCertServiceApi.middleware,
    NotificationBarServiceApi.middleware,
    BookingCancelationListServiceApi.middleware
  ),
})
setupListeners(store.dispatch);
